import { render } from "./OpenEndedQuestionSearch.vue?vue&type=template&id=be7b1c54&scoped=true"
import script from "./OpenEndedQuestionSearch.vue?vue&type=script&lang=js"
export * from "./OpenEndedQuestionSearch.vue?vue&type=script&lang=js"

import "./OpenEndedQuestionSearch.vue?vue&type=style&index=0&id=be7b1c54&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be7b1c54"]])

export default __exports__